export let EXTERNAL_VIDEO_PROCESSING_STATUSES = /*#__PURE__*/function (EXTERNAL_VIDEO_PROCESSING_STATUSES) {
  EXTERNAL_VIDEO_PROCESSING_STATUSES["DOWNLOADING"] = "DOWNLOADING";
  EXTERNAL_VIDEO_PROCESSING_STATUSES["UPLOADING"] = "UPLOADING";
  EXTERNAL_VIDEO_PROCESSING_STATUSES["IN_STORAGE"] = "IN-STORAGE";
  EXTERNAL_VIDEO_PROCESSING_STATUSES["IN_QUEUE"] = "IN-QUEUE";
  EXTERNAL_VIDEO_PROCESSING_STATUSES["INPROGRESS"] = "INPROGRESS";
  EXTERNAL_VIDEO_PROCESSING_STATUSES["PREVIEW_READY"] = "PREVIEW_READY";
  EXTERNAL_VIDEO_PROCESSING_STATUSES["READY"] = "READY";
  EXTERNAL_VIDEO_PROCESSING_STATUSES["FAILED"] = "FAILED";
  return EXTERNAL_VIDEO_PROCESSING_STATUSES;
}({});
//# sourceMappingURL=external-video-processing-statuses.js.map